export default "__VITE_ASSET__kE$Drk5f__"